<app-module-error class="flex-fill" *ngIf="!isDataLoading && (data === null || data?.KpiData.length == 0) && data?.Error != 2 && !isFirstLoad" [noData]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf="!isDataLoading && data?.Error == 2" [dateRangeTooWideIntraday]="true"></app-module-error>
<div *ngIf="data?.Error === 0" class="gridItemChildModule w-100 h-100 d-flex flex-column overflow-auto">
    <div [id]="moduleKey + '_kpiWrapper'" class="d-flex align-items-center marginAuto h-100" [hidden]="!moduleManager.showLoader">
        <div class="extended-kpi-module d-flex flex-column flex-wrap" [style]="getContainerSize()">
            <div class="extended-kpi-module-item position-relative" *ngFor="let kpiDataItem of data?.KpiData; let i=index" 
                [ngClass]="getSeparators(i)" [ngStyle]="getItemSize()">
                <cv-extended-kpi-item 
                    class="d-flex h-100 w-100 p-3 align-items-center justify-content-center position-relative"
                    [itemId]="moduleKey + '_' + i"
                    [data]="kpiDataItem" [displayItems]="displayItems"
                ></cv-extended-kpi-item>
            </div>
        </div>
    </div>
</div>
